import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "value"]

  connect() {
    this.update()
  }

  update() {
    this.valueTarget.textContent = this.inputTarget.value
  }
}
